import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "corner.rounded.16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "currentColor", fillRule: "evenodd" },
        React.createElement("path", { fillOpacity: 0.15, d: "M8.75 2.75H14V14H2.75V8.75a6 6 0 0 1 6-6z" }),
        React.createElement("path", { fillRule: "nonzero", d: "M14 2v1.5H8.75a5.25 5.25 0 0 0-5.246 5.034L3.5 8.75V14H2V8.75a6.75 6.75 0 0 1 6.513-6.746L8.75 2H14z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
